import React from 'react'
import PropTypes from 'prop-types'

import CtaButton from 'components/cta-button'

import styles from './styles.module.scss'

const Footer = ({ update, cancel, invalid }) => {
  const submit = () => {
    if (invalid) {
      return
    }

    update()
  }

  return (
    <>
      {/* Buffer element to prevent form from overflowing footer since footer is absolutely positioned at the bottom of the page */}
      <div className={styles.buffer} />
      <div className={styles.root}>
        <CtaButton size="small" onClick={submit} showDisabled={invalid}>
          Update
        </CtaButton>
        <button type="button" className={styles['close-button']} onClick={cancel}>
          Close
        </button>
      </div>
    </>
  )
}

Footer.propTypes = {
  cancel: PropTypes.func,
  update: PropTypes.func,
  invalid: PropTypes.bool,
}

export { Footer as FooterNoHoc }

export default Footer
